import React from "react";
import close from "../../../assets/images/close-icon.svg";
import styles from "./CompleteProjectModal.scss";

import { Mixpanel } from "../../../actions/mixpanel.actions";

const CompleteProjectModal = props => (
  <div className={styles.completeProjectModal}>
    <div className={styles.modalContainer}>
      <img
        src={close}
        className={styles.closebutton}
        onClick={() => {
          props.onHide();
          Mixpanel.track(
            "Project - Modal - Mark Completed - Close Mark as Complete"
          );
        }}
      />
      <div className={styles.modalContent}>
        <div className={styles.header}>
          <h2 className={styles.title}>Mark This Project as Completed</h2>
        </div>
        <div className={styles.divider}>
          <div className={styles.top} />
          <div className={styles.bottom} />
        </div>
        <div className={styles.intro}>
          <p>
            Are you sure you want to mark this project as completed? This can
            not be undone.
          </p>
        </div>
        <div className={styles.buttonContainer}>
          <button
            className={styles.whiteButton}
            onClick={() => {
              props.completeProject(props.projectId);
              props.onHide();
              Mixpanel.track(
                "Project - Modal - Mark Completed - Marked as Complete"
              );
            }}
          >
            MARK AS COMPLETE
          </button>
        </div>
        <div className={styles.buttonContainer}>
          <span
            className={styles.link}
            onClick={() => {
              props.onHide();
              Mixpanel.track(
                "Project - Modal - Mark Completed - Cancel Mark as Complete"
              );
            }}
          >
            Cancel
          </span>
        </div>
      </div>
    </div>
  </div>
);

export default CompleteProjectModal;



// WEBPACK FOOTER //
// ./src/routes/common/completeProjectModal/CompleteProjectModal.js